export default "__VITE_ASSET__DRtqRt_E__"